import React, { useState,useEffect } from "react";
import BiometricCheckController from "./BiometricCheckController";
import EmployeeEnrollmentController from "../EmployeeEnrollment/EmployeeEnrollmentController";
import { RegularButton } from "../../../common/ReusableComponent/CustomButton";
import { ReusableInput, SelectInput } from "../../../common/ReusableComponent/ReusableInput";

const BiometricCheckView = () => {
  const [activeTab, setActiveTab] = useState("attendance");
  const [currentAction, setCurrentAction] = useState(() => {
    return localStorage.getItem("biometricAction") || "IN";
  });
 useEffect(() => {
    localStorage.setItem("biometricAction", currentAction);
  }, [currentAction]);

  const {
    machineIdEnroll,
    setMachineIdEnroll,
    fingerprintIdEnroll,
    setFingerprintIdEnroll,
    enroll,
    setEnroll,
    machineIdLog,
    setMachineIdLog,
    fingerprintIdLog,
    setFingerprintIdLog,
    loadingEnroll,
    handleEnrollment,
    loadingLog,
    handleBiometricLogs,
    resetForm,
  } = BiometricCheckController();

  const { machines, employees } = EmployeeEnrollmentController();

  return (
    <div className="responsive-box">
      <h4 className="mb-4">Employee Log</h4>
      <div className="d-flex mb-4 border-bottom gap-2">
        <button
          className={`px-4 py-2 border-0 bg-transparent ${
            activeTab === "enroll"
              ? "border-bottom border-3 border-warning text-dark fw-semibold"
              : "text-muted"
          }`}
          style={{
            borderRadius: "4px 4px 0 0",
            fontSize: "16px",
            transition: "all 0.2s",
          }}
          onClick={() => setActiveTab("enroll")}
        >
          Enrollment
        </button>
        <button
          className={`px-4 py-2 border-0 bg-transparent ${
            activeTab === "attendance"
              ? "border-bottom border-3 border-warning text-dark fw-semibold"
              : "text-muted"
          }`}
          style={{
            borderRadius: "4px 4px 0 0",
            fontSize: "16px",
            transition: "all 0.2s",
          }}
          onClick={() => setActiveTab("attendance")}
        >
          Attendance
        </button>
      </div>
      {activeTab === "enroll" ? (
      <form onSubmit={handleEnrollment}>
  <div
    className="d-flex"
    style={{ gap: "20px", flexWrap: "wrap", marginTop:"40px"}}
  >

    <div style={{ flex: "1 1 200px", minWidth: "150px",}}>
      <SelectInput
        value={machineIdEnroll}
        onChange={(e) => setMachineIdEnroll(e.target.value)}
        required={true}
        options={machines.map((machine) => ({
          id: machine.machine_id,
          name: machine.machine_id,
        }))}
        label="Machine"
        placeholder="Select Machine"
        style={{ width: "100%" }}
      />
    </div>

    <div style={{ flex: "1 1 200px", minWidth: "150px" }}>
      <ReusableInput
        type="text"
        value={fingerprintIdEnroll}
        onChange={(e) => setFingerprintIdEnroll(e.target.value)}
        label="Fingerprint ID"
        placeholder=""
        required={true}
        style={{ width: "100%" }}
      />
    </div>


    <div
      className="d-flex align-items-center"
      style={{ flex: "0 0 auto", minWidth: "120px" }}
    >
      <input
        type="checkbox"
        className="form-check-input me-2"
        id="enrollCheck"
        checked={enroll}
        onChange={(e) => setEnroll(e.target.checked)}
      />
      <label htmlFor="enrollCheck" className="form-check-label">
        Enroll
      </label>
    </div>

    {/* Buttons */}
    <div className="d-flex gap-2" style={{ flex: "0 0 auto" }}>
      <RegularButton
        type="submit"
        text={
          loadingEnroll ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Checking...
            </>
          ) : (
            <>
              <i className="bi bi-check-lg" /> Check
            </>
          )
        }
        disabled={loadingEnroll || !machineIdEnroll || !fingerprintIdEnroll}
      />
      <RegularButton
        text={
          <>
            <i className="bi bi-arrow-repeat" /> Clear
          </>
        }
        onClick={resetForm}
        backgroundColor="#ffffff"
        color="#282E26"
        disabled={loadingEnroll}
      />
    </div>
  </div>
</form>

      ) : (
        <div className="row g-3 mt-4">
          {/* Machine Dropdown */}
         <div className="col-md-6">
      <SelectInput
        value={machineIdLog}
        onChange={(e) => setMachineIdLog(e.target.value)}
        required={true}
        options={machines.map((machine) => ({
          id: machine.machine_id,
          name: machine.machine_id,
        }))}
        label="Machine"
        placeholder="Select Machine"
        style={{ width: "100%" }}
      />
    </div>

          {/* Employee Dropdown */}
        <div className="col-md-6">
      <SelectInput
        value={fingerprintIdLog}
        onChange={(e) => setFingerprintIdLog(e.target.value)}
        required={true}
        options={employees.map((emp) => ({
          id: emp.fingerprint_id,
          name: emp.full_name,
        }))}
        label="Employee"
        placeholder="Select Employee"
        style={{ width: "100%" }}
      />
    </div>

          {/* IN/OUT Button aligned right */}
          <div className="col-12 d-flex justify-content-end mt-4">
            <RegularButton
              text={loadingLog ? "Processing..." : currentAction}
              onClick={async (e) => {
                await handleBiometricLogs(e, currentAction);
                setCurrentAction((prev) => (prev === "IN" ? "OUT" : "IN"));
              }}
              disabled={loadingLog || !machineIdLog || !fingerprintIdLog}
              backgroundColor={currentAction === "IN" ? "#FFAF32" : "#FFFFFF"}
              color="#000000"
            >
              <i className="bi bi-box-arrow-in-right me-2" />
              {loadingLog
                ? "Processing..."
                : currentAction === "IN"
                ? "IN"
                : "OUT"}
            </RegularButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default BiometricCheckView;
